import {
  Component,
  input,
  InputSignal,
  inject,
  signal,
  effect,
  WritableSignal,
  DestroyRef,
} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

export type IconType =
  | 'ride'
  | 'instruction'
  | 'instruction_next'
  | 'cadence'
  | 'check'
  | 'calories'
  | 'cardio'
  | 'complete_flag'
  | 'connexion'
  | 'distance'
  | 'download'
  | 'force'
  | 'halfway'
  | 'immersive'
  | 'lastKM'
  | 'load'
  | 'play_slow'
  | 'play_speed'
  | 'play'
  | 'qrcode'
  | 'slope'
  | 'social'
  | 'speed'
  | 'timer'
  | 'user'
  | 'mountain'
  | 'row'
  | 'run'
  | 'mountain-next'
  | 'watts'
  | 'podium'
  | 'pause'
  | 'warning'
  | 'video'
  | 'marker_end'
  | 'go';

@Component({
  selector: 'app-icon',
  imports: [],
  template: `<div class="icon-wrapper" [attr.data-icon]="icon()" [innerHTML]="svgContent()"></div>`,
  styleUrl: './icon.scss',
  host: {
    '[style.height.rem]': 'size()',
    '[style.width.rem]': 'size()',
  },
})
export class Icon {
  icon: InputSignal<IconType> = input.required();
  color: InputSignal<string> = input('white');
  size: InputSignal<number> = input(1.5);
  private http: HttpClient = inject(HttpClient);
  private sanitizer: DomSanitizer = inject(DomSanitizer);
  private destroyRef: DestroyRef = inject(DestroyRef);
  protected svgContent: WritableSignal<SafeHtml | null> = signal<SafeHtml | null>(null);

  constructor() {
    effect(() => {
      const color: string = this.color();
      this.http
        .get(`icons/${this.icon()}.svg`, { responseType: 'text' })
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe({
          next: (svg) => {
            this.processSvg(svg, color);
          },
          error: (error) => {
            console.error(`Failed to load icon: ${this.icon()}`, error);
          },
        });
    });
  }

  private processSvg(svg: string, color: string): void {
    const sizedSvg: string = svg.replace(/<svg\b([^>]*)>/i, (_match, attributes: string) => {
      const cleanAttributes: string = attributes
        .replace(/\swidth="[^"]*"/i, '')
        .replace(/\sheight="[^"]*"/i, '');
      return `<svg${cleanAttributes} width="100%" height="100%">`;
    });
    const modifiedSvg: string = sizedSvg.replace(/fill="(?!none")[^"]*"/g, `fill="${color}"`);
    const safeSvg: SafeHtml = this.sanitizer.bypassSecurityTrustHtml(modifiedSvg);
    this.svgContent.set(safeSvg);
  }
}
